import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  Flex,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import Sidebar from '../components/sidebar/Sidebar';
import Navbar from '../components/navbar/Navbar';

interface AdminLayoutProps {
  children?: ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgColor = useColorModeValue('background.100', 'background.900');

  return (
    <Box bg={bgColor} minH="100vh">
      <Sidebar isOpen={isOpen} onClose={onClose} />
      
      <Box
        ml={{ base: 0, md: '280px' }}
        transition="margin-left 0.3s"
        minH="100vh"
      >
        <Navbar onOpen={onOpen} />
        
        <Box
          as="main"
          p={{ base: '16px', md: '30px' }}
          pt={{ base: '90px', md: '100px' }}
          minH="calc(100vh - 60px)"
        >
          {children || <Outlet />}
        </Box>
      </Box>
    </Box>
  );
}
